import React, { useEffect } from 'react';

const AssetPreloader: React.FC = () => {
  useEffect(() => {
    const preloadAssets = async () => {
      try {
        const [
          bronze,
          silver,
          gold,
          platinum,
          diamond,
          nebula,
          tipTransfer,
          depositWallet,
          withdrawWallet,
          crab,
          octopus,
          fish,
          dolphin,
          shark,
          whale,
        ] = await Promise.all([
          import('../../assets/item-bronze.webp'),
          import('../../assets/item-silver.webp'),
          import('../../assets/item-gold.webp'),
          import('../../assets/item-platinum.webp'),
          import('../../assets/item-diamond.webp'),
          import('../../assets/item-nebula.webp'),
          import('../../assets/images/tip_transfer.webp'),
          import('../../assets/images/deposit_wallet.webp'),
          import('../../assets/images/withdraw_wallet.webp'),
          import('../../assets/levels/crab.webp'),
          import('../../assets/levels/octopus.webp'),
          import('../../assets/levels/fish.webp'),
          import('../../assets/levels/dolphin.webp'),
          import('../../assets/levels/shark.webp'),
          import('../../assets/levels/whale.webp'),
        ]);

        const assets = [
          bronze.default,
          silver.default,
          gold.default,
          platinum.default,
          diamond.default,
          nebula.default,
          tipTransfer.default,
          depositWallet.default,
          withdrawWallet.default,
          crab.default,
          octopus.default,
          fish.default,
          dolphin.default,
          shark.default,
          whale.default,
        ];

        assets.forEach((asset) => {
          const img = new Image();
          img.src = asset;
        });
      } catch (error) {
        console.error('Failed to preload assets:', error);
      }
    };

    const timer = setTimeout(preloadAssets, 1500);

    return () => clearTimeout(timer);
  }, []);

  return null;
};

export default AssetPreloader;
